<form [formGroup]="dropdownFormGroup" class="matformfield-fullwidth" appearance="outline">
    <mds-dropdown
        [closeOnPageScroll]="false"
        appearance="outline"
        [multiple]="true"
        [label]="labelName"
        placeholder="Filter by {{ labelName }}"
        [options]="data"
        [matTooltip]="data?.length === 0 ? 'No filter options' : ''"
        id="filterDropdown"
        (selectionChange)="selectionChange($event)"
        [formGrp]="dropdownFormGroup"
        formCtrlName="dropdown"
        #dropdown
    ></mds-dropdown>
</form>
